<template>
    <div class="create-swop bg-light">
        <div class="bg-white h-24 border-b border-solid border-gray-300 flex items-center">
            <div class="container p-8 mx-auto">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h2 class="text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                            Opret SWOP
                        </h2>
                    </div>
                    <div class="mt-4 flex md:mt-0 md:ml-4">
                        <button v-if="step > 1" @click="step = step - 1" type="button" class="mr-4 inline-flex items-center px-4 py-2 border border-gray-300 text-sm leading-5 font-medium rounded-md text-gray-700 bg-white hover:text-gray-500 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 active:text-gray-800 active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out">
                            Gå tilbage
                        </button>
                        <button v-if="step < 3" @click="step = step + 1" type="button" class="bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white">
                            Næste
                        </button>
                        <button v-if="step === 3" @click="showCreateAlert = true" type="button" class="bg-main border border-transparent inline-flex items-center px-4 py-2 text-sm leading-5 font-medium rounded-md text-white">
                            Opret SWOP
                        </button>
                        <custom-alert
                            v-if="showCreateAlert"
                            heading="Er oplysningerne korrekte?"
                            :description="'Serienummer<br><b>' + selection.serial + '</b><br><br>Beholder<br><b>' + selection.container.name + '</b><br><br>Medarbejder<br><b>' + selection.worker.name + '</b>'"
                            acceptText="Opret SWOP"
                            cancelText="Annullér"
                            @cancel="showCreateAlert = false"
                            @accept="createSwop()"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="page-content overflow-y-auto" style="min-height:calc(100vh - 10rem);-webkit-overflow-scrolling:touch;">
            <div class="container p-8 mx-auto bg-light">
                <div class="first-step" v-if="step === 1">
                    <div class="flex">
                        <div class="w-1/3">
                            <div class="text-xl font-medium mb-6">
                                1. Indtast serienummer
                            </div>
                        </div>
                        <div class="w-1/3">
                            <div class="max-w-xs rounded-md shadow-sm">
                                <input id="serial" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" placeholder="fx VCF352XXX ..." v-model="selection.serial" autocapitalize="characters" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="second-step" v-if="step === 2">
                    <div class="text-xl font-medium mb-6">
                        2. Vælg beholder
                    </div>
                    <div class="containers flex flex-wrap -mx-4">
                        <div class="w-1/3 px-4 mb-4" v-for="container in containers" :key="container.name">
                            <div
                                class="flex items-center justify-between single-container bg-white shadow p-4 rounded"
                                :class="{'selected': selection.container.id === container.id}"
                                @click="selection.container = container"
                            >
                                <div>
                                    {{ container.name }}
                                </div>
                                <div class="text-gray-500">
                                    {{ container.number }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="third-step" v-if="step === 3">
                    <div class="text-xl font-medium mb-6">
                        3. Vælg medarbejder
                    </div>
                    <div class="workers flex flex-wrap -mx-4">
                        <div class="w-1/3 px-4 mb-4" v-for="worker in workers" :key="worker.name">
                            <div
                                class="flex items-center justify-between single-worker bg-white shadow p-4 rounded"
                                :class="{'selected': selection.worker.id === worker.id}"
                                @click="selection.worker = worker"
                            >
                                <span>{{ worker.name }}</span>
                                <div v-if="worker.color" class="inline-block h-4 w-4 rounded-full mr-2" :style="'background:' + worker.color" />
                                <div v-else class="inline-block h-4 w-4 rounded-full bg-main mr-2" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars.scss";

    .single-worker, .single-container {

        &.selected, &.selected * {
            background: $color--main;
            color: #fff;
        }
    }

</style>

<script>
import * as containerService from '@/services/containerService'
import * as workerService from '@/services/workerService'

export default {
    data () {
        return {
            step: 1,
            containers: [],
            workers: [],
            selection: {
                serial: '',
                container: 0,
                worker: 0
            },
            showCreateAlert: false
        }
    },
    created () {
        this.getContainers()
        this.getWorkers()
    },
    methods: {
        getContainers () {
            containerService.all(null, (response) => {
                this.containers = response.data
            }, (err) => {
                // Handle error
                console.log(err)
            })
        },
        getWorkers () {
            workerService.all(null, (response) => {
                this.workers = response.data
            }, (err) => {
                // Handle error
                console.log(err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// createSwop.vue?9f787de4